export const UPDATE_SUBSCRIBER_OWNER_REQUEST =
  "UPDATE_SUBSCRIBER_OWNER_REQUEST";
export const UPDATE_SUBSCRIBER_OWNER_SUCCESS =
  "UPDATE_SUBSCRIBER_OWNER_SUCCESS";
export const UPDATE_SUBSCRIBER_OWNER_FAILURE =
  "UPDATE_SUBSCRIBER_OWNER_FAILURE";
